import { GlobalConstants } from "../../data/GlobalConstants";
import { handleResponse } from "../../util/functions";
import { getToken } from "../../helpers/helperJWT";

const url = GlobalConstants.urlApi;

const saveExcel = ({ file }) => {
    const formData = new FormData();

    formData.append('xls', file);

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': getToken()
        },
        body: formData
    };

    return fetch(`${url}/unoauno/general/saveExcel`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const getUrlPowerBi = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/general/getUrlPowerBi`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

export const generalService = {
    saveExcel,
    getUrlPowerBi
};